//function check shopify domain
export const checkShopifyDomain = (url) => {
  const domainPath = url.split(".");
  if (domainPath.length === 1) return true;
  if (domainPath.length === 2) return false;
  if (domainPath.length === 3) {
    if (domainPath[1] === "myshopify" && domainPath[2] === "com") return true;
    return false;
  }
  return false;
};

export function loadFont(fontFamily) {
  const formattedFont = fontFamily.replace(/ /g, "+");
  const fontLink = document.querySelector(
    `link[href*="fonts.googleapis.com/css?family=${formattedFont}"]`
  );

  if (!fontLink) {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = `https://fonts.googleapis.com/css?family=${formattedFont}`;
    document.head.appendChild(link);
  }
}

export const optimizeFontSizeBinarySearch = (textElement, targetHeight, initialFontSize) => {
  let minSize = 1;
  let maxSize = initialFontSize * 3;
  let bestSize = initialFontSize;
  let iterations = 0;
  const maxIterations = 25;
  const tolerance = 1;

  while (minSize <= maxSize && iterations < maxIterations) {
    const midSize = (minSize + maxSize) / 2;
    textElement.style.fontSize = midSize + "px";

    const currentHeight = textElement.clientHeight;
    const diff = Math.abs(currentHeight - targetHeight);

    if (diff <= tolerance) {
      bestSize = midSize;
      break;
    }

    if (currentHeight < targetHeight) {
      minSize = midSize + 0.2;
      bestSize = midSize;
    } else {
      maxSize = midSize - 0.2;
    }

    iterations++;
  }
  textElement.style.fontSize = bestSize + "px";
  return bestSize;
};
